import { Typography } from '@mui/material';
import { ReactNode } from 'react';

interface ILabelProps {
	children: ReactNode;
	sx?: object;
}

export const SubHeading = ({ children, sx }: ILabelProps) => (
	<Typography
		variant="caption"
		sx={{
			fontWeight: 700,
			color: 'primary.main',
			textTransform: 'uppercase',
			letterSpacing: '0.08em',
			display: 'block',
			...sx,
		}}
	>
		{children}
	</Typography>
);

export const FieldLabel = ({ children }: ILabelProps) => (
	<Typography
		variant="caption"
		sx={{
			fontWeight: 700,
			color: 'text.primary',
			textTransform: 'uppercase',
			letterSpacing: '0.08em',
			display: 'block',
			mb: 0.75,
		}}
	>
		{children}
	</Typography>
);
